import React from 'react';
import { Text } from '@highereducation/hen-ui';
import type { Step } from '../../types/types';

interface StepPreSubHeadingProps {
  step: Step;
  isFullPageExp: boolean;
}

export const StepPreSubHeading: React.FC<StepPreSubHeadingProps> = ({
  step,
  isFullPageExp,
}) => {
  if (!step.preSubHeading) return null;

  return (
    <Text
      data-test='step-preSubHeading'
      variant={isFullPageExp ? 'b3' : 'b4'}
      color='subtext'
      className='font-bold'
    >
      {step.preSubHeading}
    </Text>
  );
};
